import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';

export function getBusinessEntityTypeOptions(): SelectDropdownOption[] {
  return ['Enkeltpersonforetak', 'DA', 'ANS', 'KS', 'AS', 'NUF', 'Stiftelse', 'Kommunal enhet', 'Annet'].map((x) => ({
    value: x,
    text: x,
  }));
}
